export default __webpack_public_path__ + "static/media/cena-1.326baf6e.png";